export default __webpack_public_path__ + "static/media/hero-image-1.7d26552f.png";